import { Checkbox } from 'semantic-ui-react';
import { PropertyWithSearchesForContin, SearchForContin } from './types';
import { FlexColumnSpan, PropertyAddressText } from './styled';

interface PropTypes {
  p: PropertyWithSearchesForContin;
  selectedSearches: SearchForContin[];
  changeSearchSelection: (search: SearchForContin, checked: boolean) => void;
  changeSearchSelectionBulk: (searches: SearchForContin[], checked: boolean) => void;
}

export const OrderContinFormPropertyWithSearches = (props: PropTypes) => {
  const searchesAreAllSelected = props.p.searchesForContin.every(s => props.selectedSearches.includes(s));

  return (
    <FlexColumnSpan key={props.p.propertyId} style={{ marginTop: 12, marginBottom: 12 }}>
      <span style={{ marginTop: 8 }}>
        <Checkbox
          checked={searchesAreAllSelected}
          onChange={(e, { checked }) => props.changeSearchSelectionBulk(props.p.searchesForContin, checked)}
        />
        <PropertyAddressText>{`${props.p.propertyAddress} (${props.p.sbl})`}</PropertyAddressText>
      </span>
      {props.p.searchesForContin.map(s => {
        return (
          <span
            key={s.searchId}
            style={{
              marginTop: 8,
              marginLeft: 20,
            }}
          >
            <Checkbox
              checked={props.selectedSearches.includes(s)}
              onChange={(e, { checked }) => props.changeSearchSelection(s, checked)}
            />
            <span style={{ marginLeft: 8 }}>{s.searchType}</span>
          </span>
        );
      })}
    </FlexColumnSpan>
  );
};
